import { render, staticRenderFns } from "./DialogResetPassword.vue?vue&type=template&id=abb7e1d2"
import script from "./DialogResetPassword.vue?vue&type=script&lang=js"
export * from "./DialogResetPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports